<template>
  <base-alert
    :modalId="'remove-driver-model-' + tripID"
    icon="popup-warning-icon"
    :title="$t('remove-driver')"
    :description="$t('journey-remove-driver-warning-msg')"
  >
    <template #buttons>
      <base-button
        id="remove-trip-warning-modal-cancel-btn"
        variant="secondary"
        @click="hideModal"
        class="col-3 mb-3"
      >
        {{ $t("no") }}
      </base-button>
      <base-button
        id="remove-trip-warning-modal-submit-btn"
        variant="primary"
        @click="removeDriver"
        class="col-3 mb-3"
      >
        {{ $t("yes") }}
      </base-button>
    </template>
  </base-alert>
</template>

<script>
export default {
  props: ["tripID"],
  emits: ["removeDriver"],
  methods: {
    hideModal() {
      this.$bvModal.hide("remove-driver-model-" + this.tripID);
    },
    removeDriver() {
      this.$emit("removeDriver");
      this.hideModal();
    },
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/reservationOperations.json"),
      ar: require("@/services/i18n/locales/ar/reservationOperations.json"),
    },
  },
};
</script>
